import { render, staticRenderFns } from "./Customers.vue?vue&type=template&id=1a2055aa"
import script from "./Customers.vue?vue&type=script&lang=js"
export * from "./Customers.vue?vue&type=script&lang=js"
import style0 from "./Customers.vue?vue&type=style&index=0&id=1a2055aa&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports